// Mirrors REST_API_VERSION in shared/src/dModels/utils/Constants.js.
enum ApiVersion {
  V1 = 1,
  V2 = 2,
}

export default ApiVersion;
